var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row mt-2"},[_c('div',{staticClass:"col-md-12"},[[_c('Table',{on:{"btnPrintOnClick":_vm.btnPrintOnClick,"btnDownloadOnClick":_vm.btnDownloadOnClick}})]],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }